<a *ngIf="item?.value" [href]="'/external/' + item.value.course+'/display?display=borderless&amp;url='+item.value.url+'&lms='+item.value.lms" target="_blank">{{item.value.title || item.value.test}}</a>
<nb-form-field>
    <nb-select ngDefaultControl [(ngModel)]="tool" placeholder="Select Tool" [disabled]="checkDisable()" (selectedChange)="select($event)">
        <nb-option *ngFor="let option of tools" [value]="option">{{option.title}}</nb-option>
    </nb-select>
</nb-form-field>
<button nbButton (click)="launch()" [disabled]="!tool" *ngIf="!checkDisable() && resource">{{'setup'| translation}}</button>
<input nbInput type="text" [(ngModel)]="tool_def.url" (input)="inputUpdated()" />
<nb-checkbox ngDefaultControl [(ngModel)]="tool_def.new_tab" [disabled]="checkDisable()" (checkedChange)="inputUpdated()">
    {{'open_new_tab'| translation}}
</nb-checkbox>